import { Component, ElementRef, OnInit, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { cloneDeep, find, remove, unionBy } from 'lodash';
import { filter } from 'rxjs/operators';

import { AppConfig } from '../../app.config';
import { CitiesService } from '../../common';
import { AuthService } from '../../common/auth/auth.service';
import { FeatureService, IFeatures } from '../../common/feature.service';
import { Menu } from '../../common/permissions/menu';
import { PermissionService } from '../../common/permissions/permissions.service';
declare var jQuery: any;

@Component({
  selector: '[sidebar]',
  templateUrl: './sidebar.template.html'
})

export class SidebarComponent implements OnInit, AfterViewInit {
  $el: any;
  config: Object;
  router: Router;
  location: Location;
  sidebarMenu: Array<Menu>;
  lastRoute: string;
  isCareemAccount = false;

  constructor(
    config: AppConfig,
    el: ElementRef,
    router: Router,
    location: Location,
    private readonly authService: AuthService,
    private readonly permissionService: PermissionService,
    private readonly featureService: FeatureService,
    private readonly middlewareService: CitiesService
  ) {
    this.$el = jQuery?.(el.nativeElement);
    this.config = config.getConfig();
    this.router = router;
    this.location = location;

    const decodedToken = this.authService.decodeTokenToBase64(this.authService.getToken());
    this.isCareemAccount = !!decodedToken.careem_user_id;
  }

  initSidebarScroll(): void {
    const $sidebarContent = this.$el.find('.js-sidebar-content');
    if (this.$el.find('.slimScrollDiv').length !== 0) {
      $sidebarContent.slimscroll({
        destroy: true
      });
    }
    $sidebarContent?.slimscroll?.({
      height: window.innerHeight,
      size: '4px'
    });
  }

  activateRoute(route) {
    if (!(jQuery('main').is('.fadeInUp')) && this.lastRoute !== route) {
      jQuery('main').addClass('fadeInUp animated');
    }
    this.lastRoute = route;
  }

  changeActiveNavigationItem(location): void {
    const $newActiveLink = this.$el.find(`a[href="#${location.path().split('?')[0]}"]`);

    if (!$newActiveLink.is('.active > .collapse > li > a')) {
      this.$el.find('.active .active').closest('.collapse').collapse('hide');
    }
    this.$el.find('.sidebar-nav .active').removeClass('active');

    $newActiveLink.closest('li').addClass('active')
      .parents('li').addClass('active');

    $newActiveLink.closest('.collapse')
      .addClass('in').css('height', '')
      .siblings('a[data-toggle=collapse]')
      .removeClass('collapsed');
  }

  ngAfterViewInit(): void {
    this.changeActiveNavigationItem(this.location);
  }

  ngOnInit(): void {
    this.manipulateData();
    this.middlewareService.getCity()
      .subscribe((response) => this.manipulateData(+response['city']));
  }

  private manipulateData(cityId?: number) {
    const sgCityId = cityId || +localStorage.getItem('sg_city_id');
    this.featureService.fetchMergedConfigByCity(sgCityId)
      .subscribe((response: IFeatures) => {
        const menuItems: Menu[] = cloneDeep(this.permissionService.menuParser());
        if (!response.ENABLE_SG_ADD_VEHICLE) {
          menuItems
            .filter(item => this.isMenuForAddLeadOrOverview(item.id))
            .forEach((menuContainingAddVehicleItem: any) => {
              menuContainingAddVehicleItem.subMenu = menuContainingAddVehicleItem.subMenu.filter(
                item => !this.isSubMenuForAddVehicle(item.id)
              );
            });
        }
        if (!response.ENABLE_SG_ADD_SUPPLIER) {
          menuItems
            .filter(item => this.isMenuForAddLeadOrOverview(item.id))
            .forEach((menuContainingAddSupplierItem: any) => {
              menuContainingAddSupplierItem.subMenu = menuContainingAddSupplierItem.subMenu.filter(
                item => !this.isSubMenuForAddSupplier(item.id)
              );
            });
        }
        if (!response.ENABLE_SG_CITY_DOCUMENTS_CONFIGURATION) {
          menuItems
            .filter(item => this.isMenuForCms(item.id))
            .forEach((menuContainingCmsItem: any) => {
              menuContainingCmsItem.subMenu = menuContainingCmsItem.subMenu.filter(
                item => !this.isSubMenuForCms(item.id)
              );
            });
        }

        this.validateEntryForSupport(menuItems, response);

        this.sidebarMenu = menuItems.filter(menuItem => !menuItem.subMenu || menuItem.subMenu.length);
        jQuery(window).on('sn:resize', this.initSidebarScroll.bind(this));
        this.initSidebarScroll();
        this.router.events.pipe(
          filter(event => event instanceof NavigationEnd))
          .subscribe((event) => this.changeActiveNavigationItem(this.location));
      });
  }

  private isMenuForAddLeadOrOverview(id: string) {
    return id === 'add-lead' || id === 'overview';
  }

  private isMenuForCms(id: string) {
    return id === 'cms';
  }

  private isSubMenuForAddVehicle(id: string) {
    return id === 'add-vehicle' || id === 'overview-vehicle';
  }

  private isSubMenuForAddSupplier(id: string) {
    return id === 'add-supplier' || id === 'overview-supplier';
  }

  private isSubMenuForCms(id: string) {
    return id === 'cms-documents-upload' || id === 'replicate-city';
  }

  private validateEntryForSupport(menuItems: Menu[], featureToggles: IFeatures) {
    const supportMenuItemIndex = menuItems.findIndex(menuItem => menuItem.id === 'support');
    if (supportMenuItemIndex >= 0) {
      menuItems[supportMenuItemIndex].subMenu = menuItems[supportMenuItemIndex]
        .subMenu.filter(subMenuItem => featureToggles[subMenuItem.toggle]);
    }
  }
}
